import { db } from "./index";
import { LogException, vuePayLog } from "../utility";

const returnPromise = (callback, params) => {
    if (callback !== null && typeof callback === "function") {
        callback(params);
    }
};

/**
 * @function this method is invoked when the broadcast starts the broadcast
 * @param broadcast_id
 * @param data
 * @param callback
 */
export const createBroadcastOnFirestore = (broadcast_id, data, callback) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .set(data)
        .then(function () {
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "createBroadcast", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked when the broadcaster update request is accepted
 * update firestore <base_path>/previous_broadcast_id/change_broadcast/new_broadcast_id
 * @param prev_broadcast_id
 * @param new_broadcast_id
 * @param data
 * @param callback
 */
export const changeBroadcastOnFirestore = (
    prev_broadcast_id,
    new_broadcast_id,
    data,
    callback
) => {
    db.collection("broadcasts")
        .doc(prev_broadcast_id)
        .collection("change_broadcast")
        .doc(new_broadcast_id)
        .set(data)
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "createBroadcast", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked when the viewer sends paid group request to the broadcaster
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param user_id
 * @param data
 * @param callback
 */
export const sendRequestForPaidGroupSession = (
    broadcast_id,
    user_id,
    data,
    callback
) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("group")
        .doc(user_id)
        .set(data)
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PaidGroupRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked when the viewer deletes paid group request sent to the broadcaster
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param viewer_id
 * @param data
 * @param callback
 */
export const cancelPaidGroupRequest = (broadcast_id, user_id, callback) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("group")
        .doc(user_id)
        .delete()
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked when the viewer sends private request to the broadcaster
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param viewer_id
 * @param data
 * @param callback
 */
export const sendRequestForPrivateSession = (
    broadcast_id,
    viewer_id,
    data,
    callback
) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .doc(viewer_id)
        .set(data)
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback, {
                message: "One to one invite was sent to the user.",
                success: true,
            });
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback, {
                message:
                    "We couldn't deliver your invite to the user due to some server error.",
                success: false,
            });
        });
};

/**
 * @function this method is invoked when the viewer deletes private request sent to the broadcaster
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param viewer_id
 * @param data
 * @param callback
 */
export const cancelPrivateRequest = (broadcast_id, viewer_id, callback) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .doc(viewer_id)
        .delete()
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to get the changed broadcast status and details
 * update firestore <base_path>/<base_collection_name>/broadcast_id/change_broadcast/user_id/
 * @param broadcast_id
 * @param is_private_session
 * @param callback
 */
export const getChangeBroadcastStatus = (
    broadcast_id,
    is_private_session,
    callback
) => {
    const base_collection_name = is_private_session
        ? "private_broadcasts"
        : "broadcasts";

    db.collection(base_collection_name)
        .doc(broadcast_id)
        .collection("change_broadcast")
        .get()
        .then(function (documents) {

            if (!documents.empty) {

                documents.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    if(doc.exists){
                        const updatedData = {
                            ...doc.data(),
                            broadcast_id: doc.id,
                        };
                        returnPromise(callback(updatedData));
                    }
                });

                // if (
                //     documents.docChanges.length > 0 &&
                //     documents.docChanges[0].doc &&
                //     documents.docChanges[0].doc.data()
                // ) {
                //     const updatedData = {
                //         ...documents.docChanges[0].doc.data(),
                //         broadcast_id: documents.docChanges[0].doc.id,
                //     };
                //     returnPromise(callback(updatedData));
                // } else {
                //     returnPromise(callback(undefined));
                // }
            } else {
                // doc.data() will be undefined in this case
                //console.log("No such document!");
                returnPromise(callback(undefined));
            }
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to accept the paid group request sent by viewers
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param prev_broadcast_id
 * @param new_broadcast_id
 * @param data
 * @param callback
 */
export const acceptPaidGroupRequest = (
    prev_broadcast_id,
    new_broadcast_id,
    data,
    callback
) => {
    db.collection("broadcasts")
        .doc(prev_broadcast_id)
        .collection("paid_group")
        .doc(new_broadcast_id)
        .set(data)
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to accept the private session request sent by viewers
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param prev_broadcast_id
 * @param new_broadcast_id
 * @param data
 * @param status (1=> accept, 2=> reject)
 * @param callback
 */
export const updatePrivateSessionRequestStatus = (
    broadcast_id,
    viewer_id,
    status,
    callback
) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .doc(viewer_id)
        .update({ status: status })
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to create private session record
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param prev_broadcast_id
 * @param new_broadcast_id
 * @param callback
 */
export const createPrivateSessionRecord = (
    prev_broadcast_id,
    new_broadcast_id,
    viewer_id,
    callback
) => {
    db.collection("broadcasts")
        .doc(prev_broadcast_id)
        .collection("private_session")
        .doc(new_broadcast_id)
        .set({
            id: new_broadcast_id,
            viewer_id: viewer_id,
        })
        .then(function () {
            //console.log("Document successfully written!");
            returnPromise(callback);
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to get the status of paid group request
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param callback
 */
export const getPaidGroupRequestStatus = (broadcast_id, callback) => {

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("paid_group")
        .get()
        .then(function (documents) {


            if (!documents.empty) {

                documents.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    if(doc.exists){
                        const updatedData = {
                            ...doc.data(),
                            broadcast_id: doc.id,
                        };
                        returnPromise(callback(updatedData));
                    }
                });

                // if (
                //     documents.docChanges.length > 0 &&
                //     documents.docChanges[0].doc &&
                //     documents.docChanges[0].doc.data()
                // ) {
                //     const updatedData = {
                //         ...documents.docChanges[0].doc.data(),
                //         broadcast_id: documents.docChanges[0].doc.id,
                //     };
                //     returnPromise(callback(updatedData));
                // } else {
                //     returnPromise(callback(undefined));
                // }
            } else {
                // doc.data() will be undefined in this case
                //console.log("No such document!");
                returnPromise(callback(undefined));
            }
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

/**
 * @function this method is invoked to get the status of private session request
 * update firestore <base_path>/broadcast_id/group/user_id/
 * @param broadcast_id
 * @param callback
 */
export const getPrivateSessionRequestStatus = (broadcast_id, callback) => {

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("private_session")
        .get()
        .then(function (documents) {

            if (!documents.empty) {

                documents.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    if(doc.exists){
                        const updatedData = {
                            ...doc.data(),
                            broadcast_id: doc.data().id,
                        };
                        returnPromise(callback(updatedData));
                    }
                });

                // documents.docs.forEach(function (change) {
                //     if (change.exists) {
                //         const updatedData = {
                //             ...change.data(),
                //             broadcast_id: change.data().id,
                //         };
                //         returnPromise(callback(updatedData));
                //     } else {
                //         returnPromise(callback(undefined));
                //     }
                // });
            } else {
                // doc.data() will be undefined in this case
                //console.log("No such document!");
                returnPromise(callback(undefined));
            }
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "PrivateRequest", error);
            returnPromise(callback);
        });
};

export const subscribeToFireStore = (
    broadcast_id,
    onGroupRequestUpdate,
    onOneToOneRequestUpdate
) => {
    vuePayLog(
        "firestore.js",
        `subscribeToFireStore >> broadcast_id=${broadcast_id}`
    );

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("group")
        .onSnapshot(onGroupRequestUpdate, (error) => {
            LogException(
                "firestore.js",
                "subscribeToFireStore >> onGroupRequestUpdate",
                error
            );
        });

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .onSnapshot(onOneToOneRequestUpdate, (error) => {
            LogException(
                "firestore.js",
                "subscribeToFireStore >> onOneToOneRequestUpdate",
                error
            );
        });
};

export const subscribeToPrivateFireStore = (
    broadcast_id,
    privateSessionUpdate
) => {
    vuePayLog(
        "firestore.js",
        `subscribeToFireStore >> broadcast_id=${broadcast_id}`
    );

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("private_session")
        .onSnapshot(privateSessionUpdate, (error) => {
            LogException(
                "firestore.js",
                "subscribeToFireStore >> privateSessionUpdate",
                error
            );
        });
};

export const subscribeToBroadcastsFireStore = (broadcastUpdate) => {
    vuePayLog("firestore.js", `subscribeToBroadcastsFireStore`);

    db.collection("broadcasts").onSnapshot(broadcastUpdate, (error) => {
        LogException(
            "firestore.js",
            "subscribeToBroadcastsFireStore >> broadcastUpdate",
            error
        );
    });
};

export const subscribeToFireStoreForOneToOneRequest = (
    broadcast_id,
    viewer_id,
    onOneToOneRequestUpdateForViewer
) => {
    vuePayLog(
        "firestore.js",
        `subscribeToFireStoreForOneToOneRequest >> broadcast_id=${broadcast_id}`
    );

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .doc(viewer_id)
        .onSnapshot(onOneToOneRequestUpdateForViewer, (error) => {
            LogException(
                "firestore.js",
                "subscribeToFireStoreForOneToOneRequest >> onOneToOneRequestUpdateForViewer",
                error
            );
        });
};

/**
 * @function this method is invoked to know the the data of tip goal data
 * update firestore <base_path>/broadcast_id/tip_goal/tip_goal_id/
 * @param broadcast_id
 * @param tip_goal_id
 */

export const subscribeToFireStoreForTipGoal = (
    broadcast_id,
    tip_goal_id,
    onRequestTipGoalData
) => {

    vuePayLog(
        "firestore.js",
        `subscribeToFireStoreForTipGoal >> broadcast_id=${broadcast_id}`
    );

    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("tip_goal")
        .doc(tip_goal_id)
        .onSnapshot(onRequestTipGoalData, (error) => {
            LogException(
                "firestore.js",
                "subscribeToFireStoreForTipGoal >> onRequestTipGoalData",
                error
            );
        });
};

/**
 * @function this method is invoked to know the the status of one on one request
 * update firestore <base_path>/broadcast_id/one_to_one/viewer_id/
 * @param callback
 */
export const getOneToOneRequestStatus = (broadcast_id, viewer_id, callback) => {
    db.collection("broadcasts")
        .doc(broadcast_id)
        .collection("one_to_one")
        .doc(viewer_id)
        .get()
        .then(function (document) {
            //console.log("getOneToOneRequestStatus =>",document)
            //console.log(document.exists)
            if (document.exists) {
                //console.log(document.data())
                returnPromise(callback(document.data()));
            } else {
                returnPromise(callback(undefined));
            }
        })
        .catch(function (error) {
            console.error("Error fetching document: ", error);
            LogException("firestore.js", "getOneToOneRequestStatus", error);
            returnPromise(callback(undefined));
        });
};

export const unsubscribeToFireStore = (broadcast_id) => {
    console.log(`########################### unsubscribeToFireStore >> broadcast_id = ${broadcast_id} ###########################`)
    if (broadcast_id !== null) {

        let unsubscribeToGroup = db.collection("broadcasts")
            .doc(broadcast_id)
            .collection("group")
            .onSnapshot(function () {});

        unsubscribeToGroup();

        let unsubscribeToPrivate = db.collection("broadcasts")
            .doc(broadcast_id)
            .collection("one_to_one")
            .onSnapshot(function () {});

        unsubscribeToPrivate();

        let unsubscribe = db
            .collection("broadcasts")
            .doc(broadcast_id)
            .onSnapshot(function () {});

        unsubscribe();

    }
};


export const unsubscribeToBroadcastsFireStore = () => {
    let unsubscribe = db.collection("broadcasts").onSnapshot(function () {});
    unsubscribe();
};

/**
 * @function this method is invoked to get list of profanity words
 * update firestore <base_path>/profanity
 * @param callback
 */

export const getProfanityWords = (callback) => {
    db.collection("profanity")
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                if (doc.exists) {
                    returnPromise(callback(doc.data()));
                } else {
                    returnPromise(callback(undefined));
                }
            });
        })
        .catch(function (error) {
            console.error("Error fetching document: ", error);
            LogException("firestore.js", "getProfanityWords", error);
            returnPromise(callback(undefined));
        });
};

/**
 * @function this method is invoked to update list of profanity words for broadcaster
 * update firestore <base_path>/broadcaster/<broadcaster id>/profanity/<id>/
 * @param userId
 * @param profanityData
 */

export const updateProfanityWordToFireStore = (
    userId,
    profanityData,
    isViewer
) => {
    vuePayLog("firestore.js", `updateProfanityWordToFireStore`);
    let data = new Map();
    let collection_name = isViewer ? "users" : "broadcasters";
    db.collection(collection_name)
        .doc(userId.toString())
        .get()
        .then(function (document) {
            if (document.exists) {
                let tempData = document.data().profanity
                    ? [...document.data().profanity, profanityData]
                    : [profanityData];
                data = {
                    profanity: [...new Set(tempData)],
                };
            } else {
                data = {
                    profanity: [profanityData],
                };
            }
            db.collection(collection_name).doc(userId.toString()).set(data);
        })
        .catch(function (error) {
            console.error("Error fetching document: ", error);
            LogException("firestore.js", "updateProfanityWordToFireStore", error);
        });
};

/**
 * @function this method is used to retrieve all availability requests
 * update firestore <base_path>/broadcasts/<broadcasts id>/
 * @param broadcast_id
 */

export const getAvailabilityRequestsGroup = (broadcast_id, callback) => {
    vuePayLog("firestore.js", `getAvailabilityRequests`);

    db.collection("broadcasts")
        .doc(broadcast_id.toString())
        .collection("group")
        .get()
        .then((querySnapshot) => {
            let groupList = [];
            querySnapshot.forEach((doc) => {
                let data = doc.data();
                if (!data.user_id) {
                    data.user_id = doc.id;
                }
                groupList.push(data);
            });
            returnPromise(callback(groupList));
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "getAvailabilityRequestsGroup", error);
            returnPromise(callback(error));
        });
};

/**
 * @function this method is used to retrieve all availability requests
 * update firestore <base_path>/broadcasts/<broadcasts id>/
 * @param broadcast_id
 */

export const getAvailabilityRequestsOneToOne = (broadcast_id, callback) => {
    vuePayLog("firestore.js", `getAvailabilityRequests`);
    db.collection("broadcasts")
        .doc(broadcast_id.toString())
        .collection("one_to_one")
        .get()
        .then((querySnapshot) => {
            let oneToOneList = [];
            querySnapshot.forEach((doc) => {
                let data = doc.data();
                if (!data.user_id) {
                    data.user_id = doc.id;
                }
                oneToOneList.push(data);
            });
            returnPromise(callback(oneToOneList));
        })
        .catch(function (error) {
            console.error("Error writing document: ", error);
            LogException("firestore.js", "getAvailabilityRequestsOneToOne", error);
            returnPromise(callback(error));
        });
};

export const updateAvailabilityRequestUser = (
    userId,
    broadcast_id,
    collectionName,
    type,
    status,
    callback
) => {
    vuePayLog("firestore.js", `updateProfanityWordToFireStore`);

    db.collection("broadcasts")
        .doc(broadcast_id.toString())
        .collection(collectionName)
        .doc(userId)
        .get()
        .then(function (document) {
            if (document.exists) {
                let data = document.data();
                if (type == "favorite") {
                    data.is_favourite = status;
                } else if (type == "remove") {
                    data.status = status;
                } else if (type == "block") {
                    db.collection("broadcasts")
                        .doc(broadcast_id.toString())
                        .collection(collectionName)
                        .doc(userId)
                        .delete()
                        .then(function () {
                            returnPromise(
                                callback(
                                    getAvailabilityRequestsGroup(broadcast_id, (response) => {
                                        returnPromise(callback(response));
                                    })
                                )
                            );
                        })
                        .catch(function (error) {
                            console.error("Error removing document: ", error);
                        });
                }
                if (type !== "block") {
                    db.collection("broadcasts")
                        .doc(broadcast_id.toString())
                        .collection(collectionName)
                        .doc(userId)
                        .set(data)
                        .then(() => {
                            collectionName === "group"
                                ? returnPromise(
                                callback(
                                    getAvailabilityRequestsGroup(broadcast_id, (response) => {
                                        returnPromise(callback(response));
                                    })
                                )
                                )
                                : getAvailabilityRequestsOneToOne(broadcast_id, (response) => {
                                    returnPromise(callback(response));
                                });
                        });
                }
            }
            // db.collection(collection_name).doc(userId.toString()).set(data);
        })
        .catch(function (error) {
            console.error("Error fetching document: ", error);
            LogException("firestore.js", "updateProfanityWordToFireStore", error);
        });
};
